import { Component, Input, OnInit } from '@angular/core';
import { BcCircleLoadingComponent } from '@bancolombia/design-system-web/bc-circle-loading';
import { ErrorModel } from 'src/app/domain/models/error/error.model';
import { Adjuntos, FacturaContentModel } from 'src/app/domain/models/factura/factura.model';
import { ArchivoAdjuntoUseCase } from 'src/app/domain/usecases/archivo-adjunto/archivo-adjunto.usecase';
import { FacturaUseCase } from 'src/app/domain/usecases/factura/factura.usecase';


@Component({
  selector: 'listar-archivos-adjuntos',
  templateUrl: './listar-archivos-adjuntos.component.html',
  styleUrls: ['./listar-archivos-adjuntos.component.css']
})
export class ListarArchivosAdjuntosComponent implements OnInit {

  @Input('dataFactura') dataFactura: FacturaContentModel;

  @Input('loading') bcCircleLoading!: BcCircleLoadingComponent;

  constructor(
    private archivoAdjuntoUseCase: ArchivoAdjuntoUseCase,
    private facturaUseCase: FacturaUseCase
  ) {
    this.dataFactura = {
      numero_factura: '',
      ciudad: null,
      remitente: '',
      nit: '',
      fecha_creacion: new Date(),
      estado: {
        nombre: '',
        codigo: ''
      },
      retieca: '',
      reteiva: '',
      retefuente: '',
      total_acticipos: 0,
      iva: '',
      total_antes_impuestos: 0,
      total_incl_impuestos: 0,
      razons_adquiriente: '',
      nit_adquiriente: '',
      ciuAdquiriente: '',
      depEmision: ''
    };
  }

  ngOnInit(): void {
  }


  ordenarPorFechaAdjuntos(adjuntos: Adjuntos[]): Adjuntos[] {
    return adjuntos.sort((a, b) => {
      const fechaA = new Date(a.fecha).getTime();
      const fechaB = new Date(b.fecha).getTime();

      return fechaB - fechaA;
    });
  }

  generarURL(idAdjunto: string): void {
    this.bcCircleLoading.showCircleLoading();
    this.archivoAdjuntoUseCase.ObtenerUrl(idAdjunto)
      .subscribe({
        next: data => {
          this.downloadFile(data.url);
          this.bcCircleLoading.hideCircleLoading();
          this.facturaUseCase.openAlert('success', 'Archivo generado exitosamente', 'El archivo ha sido descargado', 5000);
        },
        error: (response: ErrorModel) => {
          this.bcCircleLoading.hideCircleLoading();
          let mensaje = response.error.message;
          this.archivoAdjuntoUseCase.openAlert('error', 'Error de sistema', mensaje, 5000);
        }
      });
  }

  downloadFile(url: string): void {
    const filename = this.getFileNameFromUrl(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
  }

  getFileNameFromUrl(enlace: string): string {
    const partes = enlace.split('/');
    const ultimoSegmento = partes[partes.length - 1];
    const valor = ultimoSegmento.split('?')[0];
    return valor;
  }

}
